import menuItems from "../components/Sidebar/_nav";
import { projects, roles, crops } from "../constants";

let setMenu = (user, projectType) => {

	let items = [menuItems.dashboard];

	if (projectType === projects.names.AGRISMART) {
		items.push(menuItems.charts);
		items.push(menuItems.data1);
		items.push(menuItems.data2);
		items.push(menuItems.agrialerts);
		items.push(menuItems.agriservice);
	}

	if (projectType === projects.names.AGRISMART2) {
		items.push(menuItems.charts2);
		items.push(menuItems.data);
		items.push(menuItems.agrialerts);
		items.push(menuItems.agriserviceV2);
		if (roles.isSuperUser(user)) {
			items.push(menuItems.configurationManager);
		}
	}

	if (projectType === projects.names.AGRIVOLTAICO) {
		items.push(menuItems.charts);
		items.push(menuItems.data1);
		items.push(menuItems.data2);
		items.push(menuItems.agrialerts);
		items.push(menuItems.agriPVservice)
	}

	if (projectType === projects.names.METEOSMART) {
		items.push(menuItems.charts);
		items.push(menuItems.data1);
		items.push(menuItems.data2);
		items.push(menuItems.agrialerts);
		items.push(menuItems.meteoservice);
	}

	if (projectType === projects.names.SOLARSMART) {
		items.push(menuItems.chartsSolar);
		items.push(menuItems.statsSolar);
		items.push(menuItems.data1Solar);
		items.push(menuItems.data2Solar);
		items.push(menuItems.alerts)
	}

	if (projectType === projects.names.SWITCH) {
		items.push(menuItems.switchData)
		items.push(menuItems.alerts)
	}

	if (projectType === projects.names.TRACKER) {
		items.push(menuItems.alerts)
	}

	if (projectType === projects.names.RADARPEST || projectType === projects.names.TRAPSCORE) {
		items.push(menuItems.chartsTrap);
		items.push(menuItems.dataTrap);
	}

	if (projectType && roles.isAdmin(user)) {
		items.push(menuItems.users);
		items.push(menuItems.settings);
	}

	if (roles.isSuperUser(user)) {
		items.push(menuItems.admin);
		items.push(menuItems.devicesManager);
	}
	return items;
};

let agriServiceMenu = () => {
	let items = []

	items.push(menuItems.medium)
	items.push(menuItems.statisticsDetails)
	items.push(menuItems.chartsFreezing)
	items.push(menuItems.chartsIrrigation)
	items.push(menuItems.chartsPhytosanitary)
	items.push(menuItems.dss)
	items.push(menuItems.maintenance)
	items.push(menuItems.contactUs)
	items.push(menuItems.goBack)

	return items
}

let agriServiceV2Menu = () => {
	let items = []

	items.push(menuItems.medium2)
	items.push(menuItems.statisticsDetailsV2)
	items.push(menuItems.charts2Freezing)
	items.push(menuItems.charts2Irrigation)
	items.push(menuItems.charts2Phytosanitary)
	items.push(menuItems.dss)
	items.push(menuItems.maintenance)
	items.push(menuItems.contactUs)
	items.push(menuItems.goBack)

	return items
}

let agriPVServiceMenu = () => {
	let items = []

	items.push(menuItems.medium)
	items.push(menuItems.statisticsDetails)
	items.push(menuItems.chartsMicroclimate)
	items.push(menuItems.maintenance)
	items.push(menuItems.contactUs)
	items.push(menuItems.goBack)

	return items
}


let cropMenu = project => {
	let items = crops.crops.map(c => (
		{
			name: c.dssName,
			url: `/dss/${c.name}/`,
			icon: c.icon,
			iconHover: c.iconHover,
			guideTopic: c.name,
			disabled: !project?.cropNames?.includes(c.name),
		}
	))

	items.push(menuItems.goBack)

	return items
}

let dssMenu = (user) => {
	let items = []

	items.push(menuItems.dssAdversities)
	items.push(menuItems.dssPhenology)
	if (roles.isAdmin(user)) {
		items.push(menuItems.dssSettings)
	}
	items.push(menuItems.goBack)

	return items
}


let meteoServiceMenu = () => {
	let items = []

	items.push(menuItems.medium)
	items.push(menuItems.statisticsDetails)
	items.push(menuItems.chartsFreezing)
	items.push(menuItems.contactUs)
	items.push(menuItems.goBack)

	return items
}

export { setMenu, agriServiceMenu, agriServiceV2Menu, agriPVServiceMenu, cropMenu, dssMenu, meteoServiceMenu };
